import React, { useState } from 'react';
import PageLayout from './../layouts/PageLayout';
import {
  emailValidation,
  firstNameValidation,
  noSpaceValidation,
  phoneOnChange,
  phoneValidation,
} from '../validation';

const EMAIL = 'Cleanairkelowna@gmail.com';

const SERVICE_OPTIONS = [
  'Residential Duct Cleaning',
  'Commercial Duct Cleaning',
  'Dryer Vent Cleaning',
  'Other',
];

function Services() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phonenumber, setPhonenumber] = useState('');
  const [serviceType, setServiceType] = useState(SERVICE_OPTIONS[0]);
  const [address, setAddress] = useState('');
  const [message, setMessage] = useState('');
  const [isFirstNameError, setIsFirstNameError] = useState(false);
  const [isEmailError, setIsEmailError] = useState(false);
  const [isPhonenumberError, setIsPhonenumberError] = useState(false);

  function openEmailCompose(e) {
    e.preventDefault();
    if (
      firstName.length > 2 &&
      emailValidation(email) &&
      phoneValidation(phonenumber)
    ) {
      const subject = encodeURIComponent(`Service request: ${serviceType} from ${firstName} ${lastName}`);
      const bodyLines = [
        `Service: ${serviceType}`,
        `Name: ${firstName} ${lastName}`,
        `Email: ${email}`,
        `Phone: ${phonenumber || ''}`,
        address ? `Address: ${address}` : '',
        message ? `Details: ${message}` : '',
      ].filter(Boolean);
      const body = encodeURIComponent(bodyLines.join('\n'));
      window.location.href = `mailto:${EMAIL}?subject=${subject}&body=${body}`;
    } else {
      if (!firstNameValidation(firstName)) setIsFirstNameError(true);
      else if (!emailValidation(email)) setIsEmailError(true);
      else if (!phoneValidation(phonenumber)) setIsPhonenumberError(true);
    }
  }

  return (
    <>
      <div className="page-content">
        <PageLayout
          pageTitle="Request a Service"
          desc="Fill in your details and we’ll get back to you with a quote. Your request will be sent by email."
        />
        <section className="content-inner contact-form-wraper style-1">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-7 col-lg-7">
                <div className="contact-box">
                  <div className="card">
                    <div className="card-body">
                      <div className="mb-4">
                        <h2 className="mb-0">Service Request</h2>
                        <p className="mb-0 font-18 text-primary">
                          Choose a service, add your details, and click Send. We’ll receive your query by email and get back to you.
                        </p>
                      </div>
                      <form className="dzForm" onSubmit={openEmailCompose}>
                        <div className="row">
                          <div className="col-xl-12 mb-3 mb-md-4">
                            <label className="form-label">Service Type</label>
                            <select
                              className="form-control"
                              value={serviceType}
                              onChange={(e) => setServiceType(e.target.value)}
                            >
                              {SERVICE_OPTIONS.map((opt) => (
                                <option key={opt} value={opt}>
                                  {opt}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-xl-6 mb-3 mb-md-4">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="First Name"
                              value={firstName}
                              onChange={(e) => {
                                setIsFirstNameError(false);
                                setFirstName(e.target.value);
                              }}
                            />
                            {isFirstNameError && (
                              <p style={{ color: 'red', fontSize: '12px' }}>
                                Please enter a valid first name (at least 2 characters).
                              </p>
                            )}
                          </div>
                          <div className="col-xl-6 mb-3 mb-md-4">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Last Name"
                              value={lastName}
                              onChange={(e) => setLastName(e.target.value)}
                            />
                          </div>
                          <div className="col-xl-6 mb-3 mb-md-4">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Email Address"
                              value={email}
                              onChange={(e) => {
                                noSpaceValidation(e.target.value) && setEmail(e.target.value);
                                setIsEmailError(false);
                              }}
                            />
                            {isEmailError && (
                              <p style={{ color: 'red', fontSize: '12px' }}>
                                Please enter a valid email address.
                              </p>
                            )}
                          </div>
                          <div className="col-xl-6 mb-3 mb-md-4">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Phone Number"
                              value={phonenumber}
                              onChange={(e) => {
                                setIsPhonenumberError(false);
                                phoneOnChange(e.target.value) && setPhonenumber(e.target.value);
                              }}
                            />
                            {isPhonenumberError && (
                              <p style={{ color: 'red', fontSize: '12px' }}>
                                Please enter a valid 10-digit phone number.
                              </p>
                            )}
                          </div>
                          <div className="col-xl-12 mb-3 mb-md-4">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address (optional)"
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                            />
                          </div>
                          <div className="col-xl-12 mb-3 mb-md-4">
                            <textarea
                              className="form-control"
                              placeholder="Additional details (optional)"
                              rows={4}
                              value={message}
                              onChange={(e) => setMessage(e.target.value)}
                            />
                          </div>
                          <div className="col-xl-12">
                            <button type="submit" className="btn btn-primary">
                              Send via Email
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-5 col-lg-5 m-b30">
                <div className="info-box">
                  <div className="info">
                    <h2>What happens next?</h2>
                    <p className="font-18">
                      When you click Send, your email client will open with your request addressed to us.
                      We’ll review it and get back to you with a quote or to schedule a visit.
                    </p>
                  </div>
                  <div className="widget widget_getintuch">
                    <ul>
                      <li>
                        <i className="fa fa-envelope"></i>
                        <span>Cleanairkelowna@gmail.com</span>
                      </li>
                      <li>
                        <i className="fa fa-phone"></i>
                        <span>(250) 899-6660</span>
                      </li>
                      <li>
                        <i className="fas fa-map-marker-alt"></i>
                        <span>140 Taylor Road, Kelowna, BC V1X 4E9</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Services;
